import { Items } from 'src/app/core/models/common/items.model';
import {
  ACTIONS_TEXT,
  IMAGE_SRC,
  STATUS_OPTIONS,
} from '../../shared-constants';

export enum ColumnIds {
  EMPLOYEE_ID = 'employeeId',
  EMAIL = 'email',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  LAST_USED = 'lastUsed',
  ADDED = 'addedDate',
  ADDED_BY = 'addedBy',
  ENABLED = 'enabled',
  ACTIONS = 'actions',
}

export const ColumnText = {
  EMPLOYEE_ID: $localize`Employee Id`.toUpperCase(),
  DRIVER_ID: $localize`Driver ID`.toUpperCase(),
  EMAIL: $localize`Email`.toUpperCase(),
  LAST_NAME: $localize`Last Name`.toUpperCase(),
  FIRST_NAME: $localize`First Name`.toUpperCase(),
  LAST_USED: $localize`Last Used`.toUpperCase(),
  ADDED: $localize`Added`.toUpperCase(),
  ADDED_BY: $localize`Added By`.toUpperCase(),
  OS: $localize`OS`,
  BUILD_VERSION: $localize`Build Version`.toUpperCase(),
  MODEL: $localize`Model`.toUpperCase(),
  ENABLED: $localize`Active`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export const STATUS_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Device Admin`,
  ACTIONS: ACTIONS_TEXT,
};

export const EXCEL_COLUMNS = [
  $localize`Employee Id`.toUpperCase(),
  // $localize`Driver ID`.toUpperCase(),
  $localize`Email`.toUpperCase(),
  $localize`Last Name`.toUpperCase(),
  $localize`First Name`.toUpperCase(),
  $localize`Last Used`.toUpperCase(),
  $localize`Added`.toUpperCase(),
  $localize`Added By`.toUpperCase(),
  // $localize`OS`,
  // $localize`Build Version`.toUpperCase(),
  // $localize`Model`.toUpperCase(),
  $localize`Active`.toUpperCase(),
  // $localize`Location`.toUpperCase(),
];

export const EXCEL_FILE_NAME = 'device-admin-data';
